import { ErrorCard } from "@fero/components";
import { useGetNominatedPurchasersForOrgQuery } from "@fero/hooks";
import { AppRoutes } from "@fero/utils";
import { Box, Skeleton } from "@mui/material";
import type { NominatedPurchaserDetailsView } from "adl-gen/ferovinum/app/api";
import {
  GridTable,
  GridTableColumnFactory,
} from "components/widgets/grid-table/grid-table";
import type React from "react";
import { createCurrencyFormatter } from "utils/currency-utils";

export const PurchasersTable: React.FC = () => {
  const {
    data: nominatedPurchasers = [],
    isLoading,
    isError,
  } = useGetNominatedPurchasersForOrgQuery();

  type NominatedPurchaserRow = {
    id?: string | number;
  } & NominatedPurchaserDetailsView;
  const factory = new GridTableColumnFactory<NominatedPurchaserRow>();

  const COLUMNS = [
    factory.makeHyperLinkColumn({
      header: "Name",
      name: "name",
      getter: (row) => row.name,
      hrefGetter: (row) =>
        `${AppRoutes.OrganisationPurchaseRequestPurchasers}/${row.nominatedPurchaserId}`,
    }),
    factory.makeTextColumn({
      header: "Credit Limit",
      name: "creditLimit",
      getter: (row) =>
        createCurrencyFormatter(row.currency)().format(Number(row.creditLimit)),
    }),
    factory.makeTextColumn({
      header: "Used",
      name: "usedCreditLimit",
      getter: (row) =>
        createCurrencyFormatter(row.currency)().format(
          Number(row.creditLimit) - Number(row.availableCredit),
        ),
    }),
    factory.makeTextColumn({
      header: "Remaining Balance",
      name: "remainingCreditLimit",
      getter: (row) =>
        createCurrencyFormatter(row.currency)().format(
          Number(row.availableCredit),
        ),
    }),
  ];
  if (isLoading) {
    return (
      <Box width={"100%"} height={800}>
        <Skeleton variant="rounded" animation="wave" height="100%" />
      </Box>
    );
  }

  if (isError) {
    return <ErrorCard />;
  }

  const rowsWithId = nominatedPurchasers.map((purchaser) => ({
    ...purchaser,
    id: purchaser.nominatedPurchaserId,
  }));

  return (
    <GridTable
      inputRowsField={rowsWithId}
      columns={COLUMNS}
      tableHeight={800}
      searchField
    />
  );
};
